// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ac0285ee]:export {\n  menuText: #303133;\n  menuActiveText: #3AC5A8;\n  subMenuActiveText: #303133;\n  menuBg: #ffffff;\n  menuHover: #3ac5a8;\n  subMenuBg: #ffffff;\n  sideMenuActive: #3ac5a8;\n  subMenuHover: #3ac5a8;\n  sideBarWidth: 240px;\n}\n.scroll-container[data-v-ac0285ee] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.scroll-container .scroll-wrapper[data-v-ac0285ee] {\n    position: absolute;\n    width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
